import { FC, useState } from 'react';
import { LayoutCarousel } from '@silverfort/sf-components';
import { useAuthenticationTypeData } from './hooks/useAuthenticationTypeData';
import { AuthenticationType, AuthenticationTypeSummary } from '../../types';
import usePaginatedDonutChart from '../../hooks/usePaginatedDonutChart';

interface AuthenticationTypeChartProps {
    authenticationTypeSummary?: AuthenticationTypeSummary;
    isLoading: boolean;
    className?: string;
    onClick: (authenticationType: AuthenticationType) => void;
    innerCircleEmptyStateClassName?: string;
}

enum DropdownOption {
    DENIED = 'denied',
    ALL = 'all'
}

const AuthenticationTypeChart: FC<AuthenticationTypeChartProps> = ({
    authenticationTypeSummary,
    isLoading,
    className,
    onClick,
    innerCircleEmptyStateClassName = ""
}) => {
    const [selectedDropdownOption, setSelectedDropdownOption] = useState<DropdownOption>(DropdownOption.DENIED);
    const relevantAuthTypeSummary =
        selectedDropdownOption === DropdownOption.DENIED
            ? authenticationTypeSummary?.denied
            : authenticationTypeSummary?.all;
    const chartData = useAuthenticationTypeData(onClick, relevantAuthTypeSummary);
    const pages = usePaginatedDonutChart({ chartData, isLoading, innerCircleEmptyStateClassName });

    return (
        <LayoutCarousel
            title="Authentication type"
            className={className}
            contentClassName="flex flex-1 flex-col justify-center px-6 flex-shrink-0 h-full min-h-[150px]"
            pages={pages}
            dropDownProps={{
                variant: 'trigger',
                items: [
                    { value: DropdownOption.DENIED, title: 'Denied' },
                    { value: DropdownOption.ALL, title: 'All authentications' }
                ],
                size: 'large',
                width: '120px',
                className: '[&]:w-[120px] border [&]:border-sf-gray-100 bg-transparent',
                selectedItems: selectedDropdownOption,
                onChange: (value) => setSelectedDropdownOption(value as DropdownOption)
            }}
        />
    );
};

export default AuthenticationTypeChart;
